(function(){
  'use strict';
  if (window.__dkCardShortNames20261012) return;
  window.__dkCardShortNames20261012 = true;
  var selector = [
    '.dk-mix-card__title',
    '.dk-plus-p0__title',
    '.dkm__name',
    '.dkt__name',
    '.dkl__name a',
    '.dkx__nm',
    '.dkx__nm a',
    '.dk-du__name',
    '.prod-card .prod-info h4',
    '.card__heading a',
    '#predictive-search-results-products-list .predictive-search__item-heading',
    '.ns-item .ns-name',
    '#wishItems .wish-name a',
    '#wishItems .wish-name',
    '#dk-cart-premium .dkcp-item__title',
    '#dkEstuche .dke-it .dke-top h3 a',
    '#dkEstuche .dke-uc b a',
    '.s-line .s-info h3 a',
    '.cart-item__title .cart-item__name',
    '.s-rec b a'
  ].join(',');
  function shorten(el){
    if (!el || el.children.length || el.closest('.pdp-info h1,.product__title h1')) return;
    var full = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var n = full.indexOf(' · ');
    if (n < 3 || n > 85 || full.length > 160) return;
    var shortName = full.slice(n + 3).trim();
    if (!shortName || shortName.length > 110) return;
    el.setAttribute('data-dk-full-product-title', full);
    var productLink = el.tagName === 'A' ? el : el.closest('a[href*=\"/products/\"]');
    if (productLink && !productLink.getAttribute('aria-label')) productLink.setAttribute('aria-label', full);
    el.textContent = shortName;
  }
  function check(root){
    if (!root) return;
    if (root.nodeType === 3) {
      if(root.parentElement && root.parentElement.matches(selector)) shorten(root.parentElement);
      return;
    }
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) shorten(root);
    var items = root.querySelectorAll(selector);
    for (var i=0; i<items.length; i++) shorten(items[i]);
  }
  function start(){
    var style=document.createElement('style');
    style.id='dk-short-card-titles-style-20261012';
    style.textContent='.card-wrapper .dk-product-title-type,.product-card-wrapper .dk-product-title-type{display:none!important;}';
    document.head.appendChild(style);
    check(document.body);
    new MutationObserver(function(mutations){
      for (var i=0;i<mutations.length;i++){
        var m=mutations[i];
        if(m.target && m.target.nodeType===1 && m.target.matches(selector)) shorten(m.target);
        for(var j=0;j<m.addedNodes.length;j++) check(m.addedNodes[j]);
      }
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();